export const statusArray =  [{
  color: '#409eff',
  text: '已操作'
},
{
  color: '#f69b07',
  text: '异常待处理'
},
{
  color: '#f56c6c',
  text: '异常'
},
{
  color: '#5FABF2',
  text: '待操作'
}
]